import { Record } from 'immutable';
import { AdjustmentType } from './adjustment-type';

const AdjustmentRecord = Record({
  eventAdjustmentId: null,
  eventId: null,
  adjustmentAmount: 0,
  adjustmentSpendAmount: 0,
  adjustmentCommRate: 0,
  adjustmentType: null,
  description: null,
  createdDate: null
});

export class Adjustment extends AdjustmentRecord {
  eventAdjustmentId: number;
  eventId: number;
  adjustmentAmount: number;
  adjustmentSpendAmount: number;
  adjustmentCommRate: number;
  adjustmentType: AdjustmentType;
  description: string;
  createdDate: Date;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/adjustment.ts